import React from 'react';
import { Box, Chip } from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { useConfig } from '../../hooks/useConfig';

interface PricingBadgesProps {
  isAnnual: boolean;
  isDevelopment: boolean;
}

export function PricingBadges({ isAnnual, isDevelopment }: PricingBadgesProps) {
  const config = useConfig();
  const discountPercent = config.INTRODUCTORY_DISCOUNT_PERCENT;
  const discountMonths = config.INTRODUCTORY_DISCOUNT_MONTHS;
  const hasIntroDiscount = discountPercent > 0;

  return (
    <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
      {hasIntroDiscount && (
        <Chip
          icon={<LocalOfferIcon />}
          label={`${discountPercent}% OFF — First ${discountMonths} Months`}
          size="small"
          color="success"
          sx={{ fontWeight: 600 }}
        />
      )}
      {isAnnual && (
        <Chip 
          label="Most popular" 
          size="small"
          sx={{ 
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            color: 'text.primary',
            fontWeight: 500
          }}
        />
      )}
      {isDevelopment && (
        <Chip 
          label="TEST MODE" 
          size="small"
          sx={{ 
            backgroundColor: 'secondary.main',
            color: 'secondary.contrastText',
            fontWeight: 500
          }}
        />
      )}
    </Box>
  );
}

